import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '@modules/i18n';

/**
 * @summary ExternalStandards
 * @extends {AoflElement}
 */
@customElement('external-standards')
class ExternalStandards extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of ExternalStandards.
   */
  constructor() {
    super();
    this.translations = translations;
  }
  /**
   * @readonly
   */
  static is = 'external-standards';

  @property({type: Array})
  ['external-standards'] = [];

  @property({type: String})
  ['row-classname'] = '';

  @property({type: Array})
  styles = [];
  /**
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles, this.styles]}
    });
  }
}

export default ExternalStandards;
